module.exports = __webpack_public_path__ + "img/character-img1.4869b5e0.png";